module.exports = __webpack_public_path__ + "static/media/stadium-cylinder.f53f7010.svg";